/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_Stat3_Line1Inputs */

const es_landing_law_stat3_line1 = /** @type {(inputs: Landing_Law_Stat3_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meses al año`)
};

const gl_landing_law_stat3_line1 = /** @type {(inputs: Landing_Law_Stat3_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meses ao ano`)
};

const en_landing_law_stat3_line1 = /** @type {(inputs: Landing_Law_Stat3_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`months per year`)
};

/**
* | output |
* | --- |
* | "months per year" |
*
* @param {Landing_Law_Stat3_Line1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_stat3_line1 = /** @type {((inputs?: Landing_Law_Stat3_Line1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_Stat3_Line1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_stat3_line1(inputs)
	if (locale === "en") return en_landing_law_stat3_line1(inputs)
	return es_landing_law_stat3_line1(inputs)
});